import { Component, Input, OnInit } from '@angular/core';
import { HeaderType } from 'src/app/domain/interfaces/header/header-type-enum';
import { IMenuOption } from 'src/app/domain/interfaces/menu/menu-option';
import { IUser } from 'src/app/domain/interfaces/user/interface-user';
import { FeatureProduct } from 'src/app/domain/models/funnel/feature-product';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';
import { MenuService } from 'src/app/infraestructure/drive-adapter/menu-service/menu.service';
import { AuthService } from 'src/app/infraestructure/drive-adapter/user-service/auth.service';
import { HideForBrandsService } from 'src/app/infraestructure/services-views/hide-for-brands-service/hide-for-brands.service';

@Component({
  selector: 'app-header-finsights',
  templateUrl: './header-finsights.component.html',
  styleUrl: './header-finsights.component.scss'
})
export class HeaderFinsightsComponent implements OnInit {
  @Input() ShowMenuMobile = true;
  @Input() headerType = HeaderType.Basic;
  public HeaderType = HeaderType;
  public ShowMenu = false;
  public UserLogin!: IUser;
  public menuItems: Array<IMenuOption> = [];
  @Input() FunnelFlow: FunnelFlow = { UserTemporary: { addresses: [] } };

  constructor(private authService: AuthService, private menuService: MenuService, private hideForBrand: HideForBrandsService) { }

  ngOnInit(): void {
    let UserLoginSubscriber = this.authService.GetUserLogin().subscribe((UserLogin: IUser) => {
      this.UserLogin = UserLogin;
      if (this.UserLogin?.id) {
        this.menuItems = this.menuService.getMenu();
        this.menuItems.forEach(option => {
          this.validateMenuOptionsByProduct(option);
        });
        this.ShowMenu = true;
      }
    });

    UserLoginSubscriber.unsubscribe();

  }

  validateMenuOptionsByProduct(option: IMenuOption) {
    if (this.hideForBrand?.getHideForBrands(option?.HideForBrands ?? [""])) {
      this.menuItems.splice(this.menuItems.indexOf(option), 1, undefined!);
    }
    else {
      option?.SubOptions?.forEach(subOption => {
        if (this.hideForBrand.getHideForBrands(subOption.HideForBrands ?? [""])) {
          option?.SubOptions?.splice(option?.SubOptions!.indexOf(subOption), 1, undefined!);
        }
      });
    }
  }
  
  productIsActive(featureProducts: FeatureProduct[]): boolean {
    if (!featureProducts || featureProducts.length == 0) {
      return false;
    }
    return featureProducts.some(featureProduct => {
      const userProduct = this.UserLogin?.userProducts?.find(
        product => product.konnektiveCampaignProduct?.featureProduct == featureProduct
      );
      return userProduct?.isActive ?? false; 
    });
  }  

  Logout() {
    this.ShowMenu = false;
    this.authService.Logout();
  }

  QuickTour() {
    this.authService.ShowToolTips();
  }
}